import { render, staticRenderFns } from "./yy-footer.vue?vue&type=template&id=2ec219cc&"
import script from "./yy-footer.vue?vue&type=script&lang=js&"
export * from "./yy-footer.vue?vue&type=script&lang=js&"
import style0 from "./yy-footer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports